import ApiDatabase from "server";

// The list already serves a renewed link, but it can still be dead (renewal
// budget reached, YouSign down, recent attempt): the api returns a good link at
// once, renews it otherwise. Any failure falls back to the stored link, as before.
export const fetchSignatureLink = ({ idMission, contract }) =>
  new Promise((resolve) => {
    ApiDatabase.getSignatureLink(
      { idMission, contractId: contract._id },
      (data) => resolve(data?.url || contract.link_signature),
      () => resolve(contract.link_signature)
    );
  });
